<template>
    <div>
        <div v-if="haveSubmitRight" class="text-right mb-3">
            <button class="btn btn-primary" @click="doUpdateCallbackInfo">{{ $t('words.save') }}</button>
        </div>
        <div class="form-group row">
            <label class="col-md-3">{{ $t('words.broadcast_update_callback') }}</label>
            <div class="col-md-9">
                <p class="text-guide">
                    {{ $t('paragraphs.broadcast_update_callback_tip') }}
                </p>
                <div class="form-radio">
                    <input type="radio" :value="true" id="use_broadcast_update_callback_yes" name="use_broadcast_update_callback" :disabled="!haveSubmitRight" v-model="use_broadcast_update_callback" @change="onChangeUseBroadcastCallback">
                    <label for="use_broadcast_update_callback_yes">{{ $t('words.use_yes') }}</label>
                </div>
                <div class="form-radio">
                    <input type="radio" :value="false" id="use_broadcast_update_callback_no" name="use_broadcast_update_callback" :disabled="!haveSubmitRight" v-model="use_broadcast_update_callback" @change="onChangeUseBroadcastCallback">
                    <label for="use_broadcast_update_callback_no">{{ $t('words.use_no') }}</label>
                </div>
                <span class="invalid-feedback" v-if="meta.errors.use_broadcast_update_callback" v-for="error in meta.errors.use_broadcast_update_callback" :key="error">{{ error }}</span>
                <div class="mt-3">
                    <input type="text" id="broadcast_update_callback_url" name="broadcast_update_callback_url" ref="broadcast_update_callback_url" :disabled="!use_broadcast_update_callback" :class="{'form-control':true, 'is-invalid':meta.errors.broadcast_update_callback_url}" :placeholder="$t('paragraphs.placeholder_callback_url')" v-model="broadcast_update_callback_url" />
                    <span class="invalid-feedback" v-if="meta.errors.broadcast_update_callback_url" v-for="error in meta.errors.broadcast_update_callback_url" :key="error">{{ error }}</span>

                    <div class="note note--info">
                        <h6 class="note__header">
                            <a @click="toggleBroadcastUpdateCallback" data-toggle="collapse" data-target="#broadcast_update_callback_api_table" aria-controls="broadcast_update_callback_api_table">
                                <i class="icon icon-info-circle-line"></i>Method : POST
                                <i :class="{
                                    'icon': true,
                                    'icon-arrow-down-sm': true,
                                    'is-rotate': broadcast_update_callback_open
                                }"></i>
                            </a>
                        </h6>
                        <div class="note__body" :class="{collapse: true}" id="broadcast_update_callback_api_table">
                            <table class="table table-api">
                                <tbody>
                                <tr>
                                    <td class="thead">version<small>string</small></td>
                                    <td>callback version</td>
                                </tr>
                                <tr>
                                    <td class="thead">service_account_key<small>string</small></td>
                                    <td>{{ $t('words.service_account_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">channel_key<small>string</small></td>
                                    <td>{{ $t('words.channel_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">stream_key<small>string</small></td>
                                    <td>{{ $t('words.stream_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">broadcast_key<small>string</small></td>
                                    <td>{{ $t('words.broadcast_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">broadcast_state<small>string</small></td>
                                    <td>
                                        <p><strong>start:</strong> {{ $t('words.stream_start') }}</p>
                                        <p><strong>stop:</strong> {{ $t('words.stream_stop') }}</p>
                                        <p><strong>pause:</strong> {{ $t('words.stream_pause') }}</p>
                                        <p><strong>resume:</strong> {{ $t('words.stream_resume') }}</p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row" v-if="generalChannel || webrtcChannel || cmafChannel">
            <label class="col-md-3">{{ $t('words.recording_file_transfer_callback') }}</label>
            <div class="col-md-9">
                <p class="text-guide">
                    {{ $t('paragraphs.recording_file_transfer_callback_tip') }}
                </p>
                <div class="form-radio">
                    <input type="radio" :value="true" id="use_recording_file_transfer_callback_yes" name="use_recording_file_transfer_callback" :disabled="!haveSubmitRight" v-model="use_recording_file_transfer_callback" @change="onChangeUseRecordingFileTransferCallback">
                    <label for="use_recording_file_transfer_callback_yes">{{ $t('words.use_yes') }}</label>
                </div>
                <div class="form-radio">
                    <input type="radio" :value="false" id="use_recording_file_transfer_callback_no" name="use_recording_file_transfer_callback" :disabled="!haveSubmitRight" v-model="use_recording_file_transfer_callback" @change="onChangeUseRecordingFileTransferCallback">
                    <label for="use_recording_file_transfer_callback_no">{{ $t('words.use_no') }}</label>
                </div>
                <span class="invalid-feedback" v-if="meta.errors.use_recording_file_transfer_callback" v-for="error in meta.errors.use_recording_file_transfer_callback" :key="error">{{ error }}</span>
                <div class="mt-3">
                    <input type="text" id="recording_file_transfer_callback_url" name="recording_file_transfer_callback_url" ref="recording_file_transfer_callback_url" :disabled="!use_recording_file_transfer_callback" :class="{'form-control':true, 'is-invalid':meta.errors.recording_file_transfer_callback_url}" :placeholder="$t('paragraphs.placeholder_callback_url')" v-model="recording_file_transfer_callback_url" />
                    <span class="invalid-feedback" v-if="meta.errors.recording_file_transfer_callback_url" v-for="error in meta.errors.recording_file_transfer_callback_url" :key="error">{{ error }}</span>

                    <div class="note note--info">
                        <h6 class="note__header">
                            <a @click="toggleRecordingFileTransferCallback" data-toggle="collapse" data-target="#recording_file_transfer_callback_api_table" aria-controls="recording_file_transfer_callback_api_table">
                                <i class="icon icon-info-circle-line"></i>Method : POST
                                <i :class="{
                                    'icon': true,
                                    'icon-arrow-down-sm': true,
                                    'is-rotate': recording_file_transfer_callback_open
                                }"></i>
                            </a>
                        </h6>
                        <div class="note__body" :class="{collapse: true}" id="recording_file_transfer_callback_api_table">
                            <table class="table table-api">
                                <tbody>
                                <tr>
                                    <td class="thead">version<small>string</small></td>
                                    <td>callback version</td>
                                </tr>
                                <tr>
                                    <td class="thead">service_account_key<small>string</small></td>
                                    <td>{{ $t('words.service_account_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">channel_key<small>string</small></td>
                                    <td>{{ $t('words.channel_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">stream_key<small>string</small></td>
                                    <td>{{ $t('words.stream_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">broadcast_key<small>string</small></td>
                                    <td>{{ $t('words.broadcast_key') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">recording_file_id<small>integer</small></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="thead">recording_file_filename<small>string</small></td>
                                    <td>{{ $t('words.recording_file_name') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">recording_file_kind<small>string</small></td>
                                    <td>{{ $t('words.recording_file_kind') }}</td>
                                </tr>
                                <tr>
                                    <td class="thead">recording_file_transfer_result<small>integer</small></td>
                                    <td>{{ $t('words.recording_file_transfer_result') }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row" v-if="useLMSCallback && !webrtcChannel">
            <label class="col-md-3">{{ $t('words.lms_callback') }}</label>
            <div class="col-md-9">
                <p class="text-guide">
                    {{ $t('paragraphs.lms_callback_tip') }}
                </p>
                <div class="form-radio">
                    <input type="radio" :value="true" id="use_lms_callback_yes" name="use_lms_callback" :disabled="!haveSubmitRight" v-model="use_lms_callback" @change="onChangeUseLmsCallback">
                    <label for="use_lms_callback_yes">{{ $t('words.use_yes') }}</label>
                </div>
                <div class="form-radio">
                    <input type="radio" :value="false" id="use_lms_callback_no" name="use_lms_callback" :disabled="!haveSubmitRight" v-model="use_lms_callback" @change="onChangeUseLmsCallback">
                    <label for="use_lms_callback_no">{{ $t('words.use_no') }}</label>
                </div>
                <span class="invalid-feedback" v-if="meta.errors.use_lms_callback" v-for="error in meta.errors.use_lms_callback" :key="error">{{ error }}</span>
                <div class="mt-3">
                    <textarea
                        id="lms_callback_url"
                        name="lms_callback_url"
                        ref="lms_callback_url"
                        v-model="lms_callback_url"
                        :disabled="!use_lms_callback"
                        :class="{'form-control':true, 'is-invalid':meta.errors.lms_callback_url}"
                        :placeholder="$t('paragraphs.placeholder_callback_url')"
                        rows="5"></textarea>
                    <span class="invalid-feedback" v-if="meta.errors.lms_callback_url" v-for="error in meta.errors.lms_callback_url" :key="error">{{ error }}</span>
                </div>
            </div>
        </div>


        <div class="form-group row" v-if="usePlayCallback && !webrtcChannel">
            <label class="col-md-3">{{ $t('words.play_callback') }}</label>
            <div class="col-md-9">
                <p class="text-guide">
                    {{ $t('paragraphs.play_callback_tip') }}
                </p>
                <div class="form-radio">
                    <input type="radio" :value="true" id="use_play_callback_yes" name="use_play_callback" :disabled="!haveSubmitRight" v-model="use_play_callback" @change="onChangeUsePlayCallback">
                    <label for="use_play_callback_yes">{{ $t('words.use_yes') }}</label>
                </div>
                <div class="form-radio">
                    <input type="radio" :value="false" id="use_play_callback_no" name="use_play_callback" :disabled="!haveSubmitRight" v-model="use_play_callback" @change="onChangeUsePlayCallback">
                    <label for="use_play_callback_no">{{ $t('words.use_no') }}</label>
                </div>
                <span class="invalid-feedback" v-if="meta.errors.use_play_callback" v-for="error in meta.errors.use_play_callback" :key="error">{{ error }}</span>
                <div class="mt-3">
                    <input type="text" id="play_callback_url" name="play_callback_url" ref="play_callback_url" :disabled="!use_play_callback" :class="{'form-control':true, 'is-invalid':meta.errors.play_callback_url}" :placeholder="$t('paragraphs.placeholder_callback_url')" v-model="play_callback_url" />
                    <span class="invalid-feedback" v-if="meta.errors.play_callback_url" v-for="error in meta.errors.play_callback_url" :key="error">{{ error }}</span>

<!--                    <div class="note note&#45;&#45;info">-->
<!--                        <h6 class="note__header">-->
<!--                            <a @click="togglePlayCallback" data-toggle="collapse" data-target="#play_callback_api_table" aria-controls="play_callback_api_table">-->
<!--                                <i class="icon icon-info-circle-line"></i>Method : POST-->
<!--                                <i :class="{-->
<!--                                    'icon': true,-->
<!--                                    'icon-arrow-down-sm': true,-->
<!--                                    'is-rotate': play_callback_open-->
<!--                                }"></i>-->
<!--                            </a>-->
<!--                        </h6>-->
<!--                        <div class="note__body" :class="{collapse: true}" id="play_callback_api_table">-->
<!--                            <table class="table table-api">-->
<!--                                <tbody>-->
<!--                                <tr>-->
<!--                                    <td class="thead">version<small>string</small></td>-->
<!--                                    <td>callback version</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">service_account_key<small>string</small></td>-->
<!--                                    <td>{{ $t('words.service_account_key') }}</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">channel_key<small>string</small></td>-->
<!--                                    <td>{{ $t('words.channel_key') }}</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">stream_key<small>string</small></td>-->
<!--                                    <td>{{ $t('words.stream_key') }}</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">broadcast_key<small>string</small></td>-->
<!--                                    <td>{{ $t('words.broadcast_key') }}</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">recording_file_id<small>integer</small></td>-->
<!--                                    <td></td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">recording_file_filename<small>string</small></td>-->
<!--                                    <td>{{ $t('words.recording_file_name') }}</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">recording_file_kind<small>string</small></td>-->
<!--                                    <td>{{ $t('words.recording_file_kind') }}</td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="thead">recording_file_transfer_result<small>integer</small></td>-->
<!--                                    <td>{{ $t('words.recording_file_transfer_result') }}</td>-->
<!--                                </tr>-->
<!--                                </tbody>-->
<!--                            </table>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        modifyMode: {
            type: [Boolean],
            require: true,
        },
        generalChannel: {
            type: [Boolean],
            require: true,
        },
        webrtcChannel: {
            type: [Boolean],
            require: true,
        },
        cmafChannel: {
            type: [Boolean],
            require: true,
        },
        currentTab: {
            type: [String],
            require: true,
        },
    },
    data() {
        return {
            tab_name: 'callback',
            use_broadcast_update_callback: false,
            broadcast_update_callback_url: '',
            broadcast_update_callback_open: false,
            use_recording_file_transfer_callback: false,
            recording_file_transfer_callback_url: '',
            recording_file_transfer_callback_open: false,
            use_lms_callback: false,
            lms_callback_url: '',
            use_play_callback: false,
            play_callback_url: '',
            play_callback_open: false,
            meta: {
                errors: {},
            },
        };
    },
    methods: {
        initialize() {
            this.use_broadcast_update_callback = this.channel.use_broadcast_update_callback;
            this.broadcast_update_callback_url = this.channel.broadcast_update_callback_url;
            this.use_recording_file_transfer_callback = this.channel.use_recording_file_transfer_callback;
            this.recording_file_transfer_callback_url = this.channel.recording_file_transfer_callback_url;
            this.use_lms_callback = this.channel.use_lms_callback;
            this.lms_callback_url = this.channel.lms_callback_url;
            this.use_play_callback = this.channel.use_play_callback;
            this.play_callback_url = this.channel.play_callback_url;
        },
        toggleBroadcastUpdateCallback() {
            this.broadcast_update_callback_open = !this.broadcast_update_callback_open;
        },
        toggleRecordingFileTransferCallback() {
            this.recording_file_transfer_callback_open = !this.recording_file_transfer_callback_open;
        },
        togglePlayCallback() {
            this.play_callback_open = !this.play_callback_open;
        },
        onChangeUseBroadcastCallback() {
            if (this.use_broadcast_update_callback) {
                this.$refs.broadcast_update_callback_url.focus();
            } else {
                this.broadcast_update_callback_url = '';
            }
        },
        onChangeUseRecordingFileTransferCallback() {
            if (this.use_recording_file_transfer_callback) {
                this.$refs.recording_file_transfer_callback_url.focus();
            } else {
                this.recording_file_transfer_callback_url = '';
            }
        },
        onChangeUseLmsCallback() {
            if (this.use_lms_callback) {
                this.$refs.lms_callback_url.focus();
            } else {
                this.lms_callback_url = '';
            }
        },
        onChangeUsePlayCallback() {
            if (this.use_play_callback) {
                this.$refs.play_callback_url.focus();
            } else {
                this.play_callback_url = '';
            }
        },
        doUpdateCallbackInfo() {
            if (!this.haveSubmitRight) {
                this.$toasted.error(this.$t('paragraphs.error.check_login_right'));
                return;
            }

            let confirmMessage;
            if (this.modifyMode) {
                confirmMessage = this.$t('paragraphs.message.confirm.update_item');
            } else {
                confirmMessage = this.$t('paragraphs.message.confirm.create_item');
            }
            if (confirm(confirmMessage)) {
                this.meta.errors = {};
                axios.patch(`${this.channelApiUri}/${this.channel.id}`, {
                    use_broadcast_update_callback: this.use_broadcast_update_callback,
                    broadcast_update_callback_url: this.broadcast_update_callback_url,
                    use_recording_file_transfer_callback: this.use_recording_file_transfer_callback,
                    recording_file_transfer_callback_url: this.recording_file_transfer_callback_url,
                    use_lms_callback: this.use_lms_callback,
                    lms_callback_url: this.lms_callback_url,
                    use_play_callback: this.use_play_callback,
                    play_callback_url: this.play_callback_url,
                }).then(() => {
                    this.$emit('changedCallback', {
                        use_broadcast_update_callback: this.use_broadcast_update_callback,
                        broadcast_update_callback_url: this.broadcast_update_callback_url,
                        use_recording_file_transfer_callback: this.use_recording_file_transfer_callback,
                        recording_file_transfer_callback_url: this.recording_file_transfer_callback_url,
                        use_lms_callback: this.use_lms_callback,
                        lms_callback_url: this.lms_callback_url,
                        use_play_callback: this.use_play_callback,
                        play_callback_url: this.play_callback_url,
                    });
                    this.$toasted.success(this.$t('paragraphs.message.success.change'));
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.change'));
                });
            }
        },
    },
    computed: {
        channelApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/channels`;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
        selectedTab() {
            return this.loadedChannel && this.currentTab === this.tab_name;
        },
    },
    watch: {
        selectedTab(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
    },
};

</script>
